var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8dea"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8dea"] = parcelRequire;
}
parcelRequire("ic7rk");
const $54b47fc030b7b21e$var$burgerBtn = document.querySelector(".burger-btn");
const $54b47fc030b7b21e$var$exitBtnNav = document.querySelector(".nav-mobile .exit-btn");
const $54b47fc030b7b21e$var$navButtons = document.querySelector(".nav__buttons");
const $54b47fc030b7b21e$var$navMobile = document.querySelector(".nav-mobile");
const $54b47fc030b7b21e$var$navDesktop = document.querySelector(".nav-desktop");
// handling mobile nav
function $54b47fc030b7b21e$var$handleNav() {
    $54b47fc030b7b21e$var$navMobile.classList.toggle("nav-mobile--active");
    $54b47fc030b7b21e$var$navButtons.classList.toggle("display-none");
}
function $54b47fc030b7b21e$var$scrollObserver() {
    // navs.forEach(nav => {
    // 	window.scrollY > 70 ? (nav.style.backgroundColor = '#132239') : (nav.style.backgroundColor = 'transparent')
    // })
    if (window.scrollY > 70) {
        $54b47fc030b7b21e$var$navDesktop.style.backgroundColor = "#132239";
        $54b47fc030b7b21e$var$navButtons.style.backgroundColor = "#132239";
    } else {
        $54b47fc030b7b21e$var$navDesktop.style.backgroundColor = "transparent";
        $54b47fc030b7b21e$var$navButtons.style.backgroundColor = "transparent";
    }
}
// listeners
$54b47fc030b7b21e$var$burgerBtn.addEventListener("click", $54b47fc030b7b21e$var$handleNav);
$54b47fc030b7b21e$var$exitBtnNav.addEventListener("click", $54b47fc030b7b21e$var$handleNav);
document.addEventListener("scroll", $54b47fc030b7b21e$var$scrollObserver);


//# sourceMappingURL=index.cc94a06f.js.map
